module.exports = __webpack_public_path__ + "static/media/color-wand.15ac48dd.svg";